const RewIcon = props => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 91' {...props}>
      <path d='m2.17,50.34l37.67,37.67c1.51,1.51,3.37,2.19,5.19,2.19,3.81,0,7.47-2.96,7.47-7.43v-29.6l34.84,34.84c1.51,1.51,3.37,2.19,5.19,2.19,3.81,0,7.47-2.96,7.47-7.43V7.43c0-4.47-3.66-7.43-7.47-7.43-1.82,0-3.68.68-5.19,2.19l-34.84,34.84V7.43c0-4.47-3.66-7.43-7.47-7.43-1.82,0-3.68.68-5.19,2.19L2.17,39.85c-2.9,2.9-2.9,7.59,0,10.49Zm51.04-6.95L90.88,5.72c.48-.48,1.04-.72,1.65-.72.95,0,2.47.66,2.47,2.43v75.34c0,1.77-1.51,2.43-2.47,2.43-.62,0-1.18-.24-1.65-.72l-37.67-37.67c-.62-.62-.71-1.33-.71-1.71s.09-1.09.71-1.71Zm-47.5,0L43.38,5.72c.48-.48,1.04-.72,1.65-.72.95,0,2.47.66,2.47,2.43v75.34c0,1.77-1.51,2.43-2.47,2.43-.62,0-1.18-.24-1.65-.72L5.71,46.81c-.62-.62-.71-1.33-.71-1.71s.09-1.09.71-1.71Z' />
    </svg>
  );
};

export default RewIcon;
